import { render, staticRenderFns } from "./addFriends.vue?vue&type=template&id=24db9dd8&scoped=true"
import script from "./addFriends.vue?vue&type=script&lang=js"
export * from "./addFriends.vue?vue&type=script&lang=js"
import style0 from "./addFriends.vue?vue&type=style&index=0&id=24db9dd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24db9dd8",
  null
  
)

export default component.exports